import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useGetDimensionGroup } from "../../hooks/useGetDimensionGroup";
export var TeaserVideo = function TeaserVideo(_ref) {
  var src = _ref.src,
    loop = _ref.loop,
    source = _ref.source,
    poster = _ref.poster,
    className = _ref.className;
  var _useState = useState(src),
    _useState2 = _slicedToArray(_useState, 2),
    currentSrc = _useState2[0],
    setCurrentSrc = _useState2[1];
  var deviceType = useGetDimensionGroup();
  useEffect(function () {
    if (deviceType && source !== null && source !== void 0 && source[deviceType]) {
      setCurrentSrc(source[deviceType]);
    }
  }, [deviceType]);
  return /*#__PURE__*/React.createElement("video", {
    autoPlay: true,
    className: className,
    controls: false,
    loop: loop,
    muted: true
    // @ts-expect-error
    ,
    playsinline: 1,
    poster: poster,
    src: currentSrc,
    "data-t-id": "components-Media"
  });
};